
export default {
  name: 'TableListRow',
  inheritAttrs: false,
  inject: {
    tableList: {
      default: {
        compact: false
      }
    }
  },
  props: {
    gap: {
      type: [String, Object],
      default: 'md'
    },
    direction: {
      type: [String, Object],
      default: null
    },
    items: {
      type: [String, Object],
      default: null
    },
    breakpoint: {
      type: String,
      default: 'lg'
    }
  },
  vessel: {
    row: {
      borderWidth: 1,
      borderRadius: 'lg',
      paddingX: 'sm',
      paddingY: 'sm',
      lg: {
        paddingX: 'lg',
        paddingY: 'md'
      }
    },
    compactRow: {
      paddingY: 'sm'
    }
  },
  computed: {
    vesselName() {
      return this.tableList.isCompact ? 'compactRow' : 'row'
    },
    flexDirection() {
      return this.direction
        ? this.direction
        : { all: 'col', [this.breakpoint]: 'row' }
    },
    flexItems() {
      return this.items
        ? this.items
        : { all: 'start', [this.breakpoint]: 'center' }
    }
  }
}
